import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  SHOW_MODAL_REGISTRATION_BUSINESS,
  SHOW_OTP_REGISTRATION_BUSINESS,
  SET_OTP_REQUEST_ID,
  SET_USER_FORM,
  RESET_CAPTCHA_REGISTRATION,
  OTP_ERROR,
} from './types';

const otpError = createReducer(null, {
  [OTP_ERROR]: (draft, { payload }) => payload.otpError,
});

const registrationForm = createReducer(
  {},
  {
    [SET_USER_FORM]: (draft, { payload }) => payload.userForm,
    [SHOW_MODAL_REGISTRATION_BUSINESS]: (draft, { payload }) =>
      payload.registrationForm,
  }
);

const requestId = createReducer(null, {
  [SET_OTP_REQUEST_ID]: (draft, { payload }) => payload.request_id,
});

const resetCaptcha = createReducer(0, {
  [RESET_CAPTCHA_REGISTRATION]: (draft, { payload }) => payload.resetCaptcha,
});

const showOtpRegistration = createReducer(false, {
  [SHOW_OTP_REGISTRATION_BUSINESS]: (draft, { payload }) =>
    payload.showOtpRegistration,
});

export default combineReducers({
  otpError,
  registrationForm,
  // FIXME camelcase
  request_id: requestId,
  resetCaptcha,
  showOtpRegistration,
});
